/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EquipmentConditionEnum = 1 | 2 | 3;

export const EquipmentConditionEnum = {
    NUMBER_1: 1 as EquipmentConditionEnum,
    NUMBER_2: 2 as EquipmentConditionEnum,
    NUMBER_3: 3 as EquipmentConditionEnum
};

